"use strict";
// Code generated by protoc-gen-ts_proto. DO NOT EDIT.
// source: ledger/transaction-status.proto
//
// GitHub:
// https://github.com/search?q=repo%3Agetstep%2Fserver+path%3Aproto%2Fledger%2Ftransaction-status.proto&type=code
Object.defineProperty(exports, "__esModule", { value: true });
exports.transactionStatusToJSON = exports.transactionStatusFromJSON = exports.TransactionStatus = void 0;
/* eslint-disable */
const protobufPackage = 'com.step.common.transaction.proto';
/**
 * Transaction status used for optimistically appending transactions to the DB
 * and then conditionally committing or rolling back.
 *
 * This was ported to a proto from a Kotlin Enum, which is why INVALID is not
 * assigned to 0.
 */
var TransactionStatus;
(function (TransactionStatus) {
    TransactionStatus["PENDING"] = "PENDING";
    TransactionStatus["ROLLED_BACK"] = "ROLLED_BACK";
    TransactionStatus["COMMITTED"] = "COMMITTED";
    TransactionStatus["INVALID"] = "INVALID";
    TransactionStatus["UNRECOGNIZED"] = "UNRECOGNIZED";
})(TransactionStatus || (exports.TransactionStatus = TransactionStatus = {}));
function transactionStatusFromJSON(object) {
    switch (object) {
        case 0:
        case 'PENDING':
            return TransactionStatus.PENDING;
        case 1:
        case 'ROLLED_BACK':
            return TransactionStatus.ROLLED_BACK;
        case 2:
        case 'COMMITTED':
            return TransactionStatus.COMMITTED;
        case 3:
        case 'INVALID':
            return TransactionStatus.INVALID;
        case -1:
        case 'UNRECOGNIZED':
        default:
            return TransactionStatus.UNRECOGNIZED;
    }
}
exports.transactionStatusFromJSON = transactionStatusFromJSON;
function transactionStatusToJSON(object) {
    switch (object) {
        case TransactionStatus.PENDING:
            return 'PENDING';
        case TransactionStatus.ROLLED_BACK:
            return 'ROLLED_BACK';
        case TransactionStatus.COMMITTED:
            return 'COMMITTED';
        case TransactionStatus.INVALID:
            return 'INVALID';
        case TransactionStatus.UNRECOGNIZED:
        default:
            return 'UNRECOGNIZED';
    }
}
exports.transactionStatusToJSON = transactionStatusToJSON;
//# sourceMappingURL=transaction-status.js.map